<template>
  <div class="h-100">
    <notifications classes="vvs-notification" />
    <transition name="fade-in-up">
      <div
        v-if="isAppLoading"
        class="pre-loader"
        :class="{ 'pre-loader--transparent': isInitialized }"
      >
        <div class="loader"><div class="heart"></div></div>
      </div>
    </transition>
    <template v-if="maintenanceModeActive">
      <app-maintenance-mode></app-maintenance-mode>
    </template>
    <template v-else>
      <app-header></app-header>
      <transition
        v-if="!maintenanceModeActive && isInitialized"
        name="fade-in-up"
      >
        <router-view :key="$route.path"></router-view>
      </transition>
    </template>
  </div>
</template>

<script>
import AppHeader from '@/layouts/AppHeader';
import AppMaintenanceMode from '@/layouts/AppMaintenanceMode';

export default {
  name: 'App',
  components: {
    AppHeader,
    AppMaintenanceMode,
  },
  computed: {
    isInitialized() {
      return this.$store.getters.getIsInitialized;
    },
    isAppLoading() {
      return this.$store.getters.getIsAppLoading;
    },
    maintenanceModeActive() {
      let isActive = this.$store.getters.getMaintenanceModeActive;

      if (isActive && this.$store.getters.getMaintenanceModeOnlyProduction) {
        isActive = this.$mode === 'production';
      }

      return isActive;
    },
  },
  async created() {
    if (!this.$store.getters.getIsInitialized) {
      await this.$store.dispatch('init');
      this.$nextTick(() => {
        window.prerenderReady = true;
      });
    }
  },
};
</script>
